import styled from 'styled-components'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.theme.forecast.pageBackground1};
`

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: ${(props) => props.theme.forecast.secondaryText};
  height: 100%;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
  color: ${(props) => props.theme.forecast.secondaryText};
  height: 100%;
`

export const PreviewPane = styled.div`
  display: flex;
  height: 100%;
  min-height: 0;
  width: 100%;
`

export const NoResults = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${(props) => props.theme.forecast.secondaryText};
  font-size: 0.875rem;
  flex: 1;
`
